<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="1200px" persistent v-model="dialogForm">
        <v-card>
          <v-toolbar color="grey lighten-4" flat dark>
            <v-toolbar-title class="text-h6 grey--text">Adicionar Pessoa</v-toolbar-title>
            <v-spacer />
            <v-btn @click="toggleForm" fab outlined dark x-small color="red">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <PessoaForm />
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PessoaForm from './Form.vue';

export default {
  name: 'ModalPessoaForm',
  components: { PessoaForm },
  data: () => ({}),
  computed: {
    ...mapState('pessoa', ['dialogForm']),
  },
  methods: {
    ...mapActions('pessoa', ['toggleForm']),
  },
};
</script>
